import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=4d5d636e&scoped=true&"
import script from "./newsletter.vue?vue&type=script&lang=ts&"
export * from "./newsletter.vue?vue&type=script&lang=ts&"
import style0 from "./newsletter.vue?vue&type=style&index=0&id=4d5d636e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d636e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4d5d636e', component.options)
    } else {
      api.reload('4d5d636e', component.options)
    }
    module.hot.accept("./newsletter.vue?vue&type=template&id=4d5d636e&scoped=true&", function () {
      api.rerender('4d5d636e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/newsletter.vue"
export default component.exports